export const ActionTypes = {
  FETCH_ALL: 'services/rawMaterial/fetch_all',
  FETCH_ALL_SUCCESS: 'services/rawMaterial/fetch_all_success',
  SET_LOADER_STATUS: 'services/rawMaterial/set_loader_status',
  SET_ALL: 'services/rawMaterial/set_all',
  ADD_OR_UPDATE_RAW_MATERIAL: 'services/rawMaterial/add_or_update_rawMaterial',
  DELETE_RAW_MATERIAL: 'services/rawMaterial/delete_rawMaterial',
};

const fetchAll = ({ rawMaterialParams }) => ({
  rawMaterialParams,
  type: ActionTypes.FETCH_ALL,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allRawMaterial }) => ({
  allRawMaterial,
  type: ActionTypes.SET_ALL,
});

const addorUpdateRawMaterial = ({
  rawMaterialData,
  actionName,
  rawMaterialParams,
}) => ({
  rawMaterialData,
  actionName,
  rawMaterialParams,
  type: ActionTypes.ADD_OR_UPDATE_RAW_MATERIAL,
});

const deleteRawMaterial = ({ id, rawMaterialParams }) => ({
  id,
  rawMaterialParams,
  type: ActionTypes.DELETE_RAW_MATERIAL,
});

export default {
  fetchAll,
  setAll,
  setLoader,
  addorUpdateRawMaterial,
  deleteRawMaterial,
};
